import * as actions from "./actionsTypes";

const initialData = {
  loadingUnlinkTemplates: false,
  saveLoadingUnlinkTemplates: false,
  unlinkTemplatesLength: 0,
  unlinkTemplates: [],
  unlinkTemplatesError: "",
  formError: "",
};

export default function UnlinkTemplatesReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_UNLINK_TEMPLATES:
      return { ...state, loadingUnlinkTemplates: action.payload };
    case actions.SAVE_LOADING_UNLINK_TEMPLATES:
      return { ...state, saveLoadingUnlinkTemplates: action.payload };
    case actions.GET_UNLINK_TEMPLATES:
      return {
        ...state,
        unlinkTemplates: action.payload.unlinkTemplates,
        unlinkTemplatesLength: action.payload.unlinkTemplatesLength,
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.UNLINK_TEMPLATES_FAIL:
      return { ...state, unlinkTemplatesError: action.payload };
    default:
      return state;
  }
}
